import { Component, Ref } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";
import { UnitSwitcher } from '../UnitSwitcher/UnitSwitcher';

/**
 * Product Details
 */
@Component
export class ProductSubtitle extends ThemeComponent {
    @Ref({required: false}) unitConvert!: HTMLElement;
    private unitSwitcher: UnitSwitcher|null = document.querySelector('unit-switcher');
    private allUnitSwitchers: NodeListOf<UnitSwitcher> = document.querySelectorAll('unit-switcher');

    init() {
        for (const unitSwitcher of this.allUnitSwitchers) {
            this.$subscribe(unitSwitcher.unitChange, () => {
                this.updateFromUnitSwitch();
            });
        }
    }

    updateFromUnitSwitch() {
        const dimensions = this.unitConvert?.getAttribute('data-mm');
        const updatedValue = this.unitSwitcher?.updateUnitValue(String(dimensions)) || '';
        this.unitConvert.textContent = updatedValue;
    }
}
